export function isNumberString(str: string) {
  const trimmed = str.trim();
  return Boolean(trimmed && !Number.isNaN(+trimmed) && Number.isFinite(+trimmed));
}
